export const keySkeleton = {
  wrapper: {
    display: {
      laptop: "flex",
    },
    alignItems: {
      laptop: "center",
    },
    justifyContent: {
      laptop: "center",
    },
    mx: {
      mobile: "1.5rem",
      tablet: "2.438rem",
      laptop: "unset",
    },
    mb: {
      tablet: "4.188rem",
      laptop: "10rem",
    },
  },
  container: {
    mb: {
      mobile: "5rem",
      tablet: "1.5rem",
    },
    alignItems: {
      tablet: "center",
      justifyContent: "center",
    },
    maxWidth: {
      laptop: "18rem",
      desktop: "21.875rem",
    },
    mx: {
      laptop: "0.625rem",
    },
  },
  image: {
    margin: {
      mobile: "0 auto 3rem",
      tablet: "0 1.875rem 3rem",
      laptop: "0 auto 3rem",
    },
    width: "12.625rem",
    height: "12.625rem",
  },
  textContainer: {
    alignItems: {
      mobile: "center",
      tablet: "unset",
      laptop: "center",
    },
    justifyContent: {
      mobile: "center",
      tablet: "left",
    },
  },
  heading: {
    width: {
      mobile: "50vw",
      tablet: "20vw",
      laptop: "12vw",
    },
    my: "2rem",
  },
  text: {
    width: {
      mobile: "85vw",
      tablet: "55vw",
      laptop: "21.875rem",
    },
  },
};
